import {ZodObject, ZodRawShape} from 'zod'
import {useLocation} from 'react-router-dom'

export const useParsedLocationState = <T extends ZodRawShape>(locationStateSchema: ZodObject<T>) => {
    const location = useLocation()
    return locationStateSchema.safeParse(location.state)
}
